// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.svg-container {
    display: flex;
    align-items: center;
    height: 15vh; 
    padding: 10px;
}

.png-container {
    display: flex;
    align-items: center;
    height: 10vh; 
    padding: 10px;
}
.header{
    height: 65px;
    display: flex;
    align-items: center;
}

.header2{
    height: 110px;
    display: flex;
    align-items: center;
}

.svg {
    height: 85px; 
    margin-left: 50px;
}

.png{
    height: 40px;
    margin-left: 50px;
}

.navbar {
    background-color: #F1B82D;
    padding: 10px 20px;
    display:flex;
    justify-content: space-between !important;
    align-items: center;
    height: 20px;
}

.nav-list {
    list-style: none;
    margin: 0;
    padding: 10px;
    display: flex;
}

.nav-item {
    display: flex;
    margin-left: 20px;
    justify-content: space-between !important;
    font-weight: 400;
}

.nav-item a {
    color: black;
    text-decoration: none;
}

.dropdown {
    position: relative;
    padding-left: 20px;
    justify-content: space-between !important;
}

.dropdown-content {
    display: none;
    position: absolute;
    background-color: #f9f9f9;
    min-width: 100px;
    z-index: 1;
}

.dropdown:hover .dropdown-content {
    display: block;
}

.dropdown-content a {
    color: #333;
    padding: 12px 16px;
    text-decoration: none;
    display: block;
}

.dropdown-content a:hover {
    background-color: #ddd;
}

.dropdown-content .badge {
    position: absolute;
    top: -10px;
    right: -10px;
    padding: 5px 10px;
    border-radius: 50%;
    background: red;
    color: white;
  }

.signout-button {
    color: black;
    background-color: #F1B82D;
    padding: 5px;
    border-radius: 5px;
    text-decoration: none;
    align-items: center;
    margin-left: auto;
    margin-right: 40px;
}`, "",{"version":3,"sources":["webpack://./src/pages/style/NavBar.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,mBAAmB;IACnB,YAAY;IACZ,aAAa;AACjB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,YAAY;IACZ,aAAa;AACjB;AACA;IACI,YAAY;IACZ,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,YAAY;IACZ,iBAAiB;AACrB;;AAEA;IACI,YAAY;IACZ,iBAAiB;AACrB;;AAEA;IACI,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,yCAAyC;IACzC,mBAAmB;IACnB,YAAY;AAChB;;AAEA;IACI,gBAAgB;IAChB,SAAS;IACT,aAAa;IACb,aAAa;AACjB;;AAEA;IACI,aAAa;IACb,iBAAiB;IACjB,yCAAyC;IACzC,gBAAgB;AACpB;;AAEA;IACI,YAAY;IACZ,qBAAqB;AACzB;;AAEA;IACI,kBAAkB;IAClB,kBAAkB;IAClB,yCAAyC;AAC7C;;AAEA;IACI,aAAa;IACb,kBAAkB;IAClB,yBAAyB;IACzB,gBAAgB;IAChB,UAAU;AACd;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,qBAAqB;IACrB,cAAc;AAClB;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,kBAAkB;IAClB,UAAU;IACV,YAAY;IACZ,iBAAiB;IACjB,kBAAkB;IAClB,eAAe;IACf,YAAY;EACd;;AAEF;IACI,YAAY;IACZ,yBAAyB;IACzB,YAAY;IACZ,kBAAkB;IAClB,qBAAqB;IACrB,mBAAmB;IACnB,iBAAiB;IACjB,kBAAkB;AACtB","sourcesContent":[".svg-container {\n    display: flex;\n    align-items: center;\n    height: 15vh; \n    padding: 10px;\n}\n\n.png-container {\n    display: flex;\n    align-items: center;\n    height: 10vh; \n    padding: 10px;\n}\n.header{\n    height: 65px;\n    display: flex;\n    align-items: center;\n}\n\n.header2{\n    height: 110px;\n    display: flex;\n    align-items: center;\n}\n\n.svg {\n    height: 85px; \n    margin-left: 50px;\n}\n\n.png{\n    height: 40px;\n    margin-left: 50px;\n}\n\n.navbar {\n    background-color: #F1B82D;\n    padding: 10px 20px;\n    display:flex;\n    justify-content: space-between !important;\n    align-items: center;\n    height: 20px;\n}\n\n.nav-list {\n    list-style: none;\n    margin: 0;\n    padding: 10px;\n    display: flex;\n}\n\n.nav-item {\n    display: flex;\n    margin-left: 20px;\n    justify-content: space-between !important;\n    font-weight: 400;\n}\n\n.nav-item a {\n    color: black;\n    text-decoration: none;\n}\n\n.dropdown {\n    position: relative;\n    padding-left: 20px;\n    justify-content: space-between !important;\n}\n\n.dropdown-content {\n    display: none;\n    position: absolute;\n    background-color: #f9f9f9;\n    min-width: 100px;\n    z-index: 1;\n}\n\n.dropdown:hover .dropdown-content {\n    display: block;\n}\n\n.dropdown-content a {\n    color: #333;\n    padding: 12px 16px;\n    text-decoration: none;\n    display: block;\n}\n\n.dropdown-content a:hover {\n    background-color: #ddd;\n}\n\n.dropdown-content .badge {\n    position: absolute;\n    top: -10px;\n    right: -10px;\n    padding: 5px 10px;\n    border-radius: 50%;\n    background: red;\n    color: white;\n  }\n\n.signout-button {\n    color: black;\n    background-color: #F1B82D;\n    padding: 5px;\n    border-radius: 5px;\n    text-decoration: none;\n    align-items: center;\n    margin-left: auto;\n    margin-right: 40px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
